import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TrendUp } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export default function PatternsCard() {
  const [patterns, setPatterns] = useState(null);
  const [acted, setActed] = useState({});

  const load = () => api.get("/notes/quick/patterns").then((r) => setPatterns(r.data.patterns)).catch(() => setPatterns([]));
  useEffect(() => { load(); }, []);

  const act = async (p) => {
    try {
      await api.post("/notes/quick/pattern-followup", {
        follow_up: p.action.follow_up, days: p.action.days,
        client_id: p.person_kind === "client" ? p.person_id : "",
        employee_id: p.person_kind === "employee" ? p.person_id : "",
        client_name: p.person_kind === "client" ? p.person : "",
        employee_name: p.person_kind === "employee" ? p.person : "",
        pattern_key: p.key,
      });
      setActed((s) => ({ ...s, [p.key + p.person_id]: true }));
      toast.success("Follow-up created — it's on the dashboard and calendar");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  if (!patterns || patterns.length === 0) return null;
  return (
    <div className="mb-6 rounded-xl border border-[#B7791F]/30 bg-[#B7791F]/5 p-6 shadow-sm" data-testid="patterns-card">
      <p className="flex items-center gap-2 font-heading text-lg font-semibold text-stone-900">
        <TrendUp size={18} className="text-[#8a5d14]" /> Patterns emerging
      </p>
      <p className="mt-1 text-xs text-stone-500">Spotted across recent notes — worth acting on before they grow.</p>
      <div className="mt-3 space-y-2">
        {patterns.map((p, i) => (
          <div key={p.key + p.person_id} className="flex flex-wrap items-center gap-2 rounded-lg border border-stone-200 bg-white p-3" data-testid={`pattern-row-${i}`}>
            <p className="w-full text-sm leading-relaxed text-stone-700 sm:w-auto sm:flex-1">{p.text}</p>
            <Link to={p.person_kind === "client" ? `/clients/${p.person_id}` : `/team/${p.person_id}`}
              className="text-xs font-semibold text-primary hover:underline" data-testid={`pattern-link-${i}`}>{p.person}</Link>
            {p.action && (acted[p.key + p.person_id] ? (
              <span className="text-xs font-semibold text-[#1e8449]" data-testid={`pattern-done-${i}`}>Follow-up created ✓</span>
            ) : (
              <button type="button" onClick={() => act(p)}
                className="rounded-full bg-[#B7791F] px-3 py-1.5 text-[11px] font-semibold text-white transition-colors hover:bg-stone-900"
                data-testid={`pattern-action-${i}`}>
                {p.action.label} → follow-up in {p.action.days} days
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
